<script>
  import { onMount } from 'svelte';
  import fetchAdminAPI from '../adminApi.js';

  export let authData;

  let rewards = [];
  let loading = true;
  let error = null;
  let editingReward = null; // { day, reward_type, reward_amount, reward_description, is_active }

  const rewardTypes = ['stars', 'spins', 'unique_prize']; // Пример, должен соответствовать бэкенду

  onMount(() => {
    loadRewards();
  });

  async function loadRewards() {
    loading = true;
    error = null;
    const result = await fetchAdminAPI('/daily-rewards', 'GET', null, authData);
    if (result.success) {
      rewards = result.data || [];
      // Дополним до 13 дней, если бэкенд вернул меньше (на случай если нет записей в БД)
      // Бэкенд должен сам обеспечить наличие 13 записей при инициализации
    } else {
      error = result.message;
      rewards = [];
    }
    loading = false;
  }

  function startEdit(reward) {
    editingReward = { ...reward }; // Копируем для редактирования
  }

  async function handleUpdateReward() {
    if (!editingReward || editingReward.Day < 1) return;

    const payload = {
      reward_type: editingReward.RewardType,
      reward_amount: Number(editingReward.RewardAmount), // Убедимся, что это число
      reward_description: editingReward.RewardDescription === "" ? null : editingReward.RewardDescription,
      is_active: editingReward.IsActive,
    };

    const result = await fetchAdminAPI(`/daily-rewards/${editingReward.Day}`, 'PATCH', payload, authData);
    if (result.success) {
      editingReward = null;
      loadRewards();
    } else {
      alert(`Ошибка обновления награды дня ${editingReward.Day}: ${result.message}`);
    }
  }

  function cancelEdit() {
    editingReward = null;
  }
</script>

<div class="daily-rewards-admin-section">
  <div class="admin-section-header">
    <h2>Управление ежедневными наградами</h2>
    <!-- Здесь нет кнопки "Создать", т.к. дни фиксированы -->
  </div>

  <div class="admin-card">
    {#if loading}
      <div style="text-align:center; padding: 30px 0;">
        <div class="spinner-large" style="margin: 0 auto 10px auto;"></div>
        <p>Загрузка наград...</p>
      </div>
    {:else if error}
      <p style="color: #d9534f; text-align:center; padding: 20px;">Ошибка: {error}</p>
    {:else if rewards.length === 0}
        <p style="text-align:center; padding: 20px; color: #555;">Данные о наградах не найдены.</p>
    {:else}
      <div class="table-responsive-wrapper">
        <table class="admin-table daily-rewards-table">
          <thead>
            <tr>
              <th>День</th>
              <th>Тип награды</th>
              <th>Кол-во</th>
              <th>Описание (ID уник. приза)</th>
              <th>Активно</th>
              <th style="text-align: right;">Действия</th>
            </tr>
          </thead>
          <tbody>
            {#each rewards as reward (reward.Day)}
              <tr class:editing-row={editingReward && editingReward.Day === reward.Day}>
                <td>{reward.Day}</td>
                {#if editingReward && editingReward.Day === reward.Day}
                  <td>
                    <select bind:value={editingReward.RewardType} class="inline-edit-field">
                      {#each rewardTypes as type (type)}
                        <option value={type}>{type}</option>
                      {/each}
                    </select>
                  </td>
                  <td><input type="number" bind:value={editingReward.RewardAmount} min="0" class="inline-edit-field" style="max-width: 80px;"></td>
                  <td><input type="text" bind:value={editingReward.RewardDescription} placeholder="ID или пусто" class="inline-edit-field"></td>
                  <td style="text-align: center;"><input type="checkbox" bind:checked={editingReward.IsActive} class="inline-edit-checkbox"></td>
                  <td class="admin-actions" style="text-align: right;">
                    <button class="admin-action-button admin-save" on:click={handleUpdateReward}>Сохранить</button>
                    <button class="admin-action-button admin-cancel" on:click={cancelEdit}>Отмена</button>
                  </td>
                {:else}
                  <td>{reward.RewardType}</td>
                  <td>{reward.RewardAmount}</td>
                  <td>{reward.RewardDescription || '–'}</td>
                  <td style="text-align: center;">
                     <span class:status-active={reward.IsActive} class:status-inactive={!reward.IsActive}>
                        {reward.IsActive ? 'Да' : 'Нет'}
                     </span>
                  </td>
                  <td class="admin-actions" style="text-align: right;">
                    <button class="admin-action-button admin-edit" on:click={() => startEdit(reward)}>Редакт.</button>
                  </td>
                {/if}
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    {/if}
  </div>
</div>

      
<style>
  .table-responsive-wrapper { overflow-x: auto; }
  .daily-rewards-table :global(.inline-edit-field) { /* Используем :global, если класс внутри each */
    padding: 6px 8px;
    font-size: 0.9em;
    background-color: rgba(10, 20, 30, 0.9);
    border: 1px solid rgba(135, 195, 255, 0.4);
    color: #E1E9F0;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
  }
  .daily-rewards-table :global(.inline-edit-field:focus) {
    background-color: rgba(15, 25, 35, 1);
    border-color: #61A6FF;
  }
  .daily-rewards-table :global(.inline-edit-checkbox) {
    transform: scale(1.1);
    accent-color: #61A6FF;
  }
  .daily-rewards-table tr.editing-row td {
    background-color: rgba(97, 166, 255, 0.07) !important; /* Важно, чтобы перебить hover */
  }

  .status-active, .status-inactive { /* Повторение для независимости компонента */
    padding: 4px 10px;
    border-radius: 16px;
    font-size: 0.8em;
    font-weight: 500;
    display: inline-block;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .status-active {
    color: #6EE7B7; background-color: rgba(52, 211, 153, 0.15); border: 1px solid rgba(52, 211, 153, 0.3);
  }
  .status-inactive {
    color: #9CA3AF; background-color: rgba(156, 163, 175, 0.1); border: 1px solid rgba(156, 163, 175, 0.2);
  }
</style>

    